export default "__VITE_ASSET__BCmOGYl8__"